module.exports = __webpack_public_path__ + "img/09.65214ec9.jpg";